import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-body p-2 d-flex align-items-center justify-content-center" }
const _hoisted_3 = { style: {"height":"200px","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radar_chart = _resolveComponent("radar-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h5", { class: "text-truncate mb-0" }, [
        _createElementVNode("i", { class: "fas fa-bullseye fa-fw text-warning" }),
        _createElementVNode("span", null, " Distribución de Cuotas")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_radar_chart, {
          data: _ctx.chartData,
          options: _ctx.chartOptions,
          plugins: _ctx.plugins
        }, null, 8, ["data", "options", "plugins"])
      ])
    ])
  ]))
}